<template>
    <div>
        <div class="app-main__inner">
            <TituloComponente icono-titulo="fas fa-clipboard-list" texto-titulo="Tipos de liquidación"  :to-create-action="{name:'NuevoTipoLiquidacion'}" to-create-text="Nuevo tipo"/>
            <div class="tab-content">
                <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="main-card mb-3 card">
                                <div class="card-body">
                                    <h5 class="card-title">Listado de tipos de liquidación</h5>
                                     <DataList ref="datatable" url="/tipoliquidacion" :fields="fields" :rowClick="mostrarOpciones"></DataList>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>                               
        </div>
    </div>
</template>
<script>
import TituloComponente from '@/components/layouts/TituloComponente';
import axios from 'axios';
//import Categoria from '@/models/categoria';
import DataList from '@/components/layouts/DataList';
import Swal from "sweetalert2";
export default {
    name: "ListarTipoLiquidacion",
    components: {
        TituloComponente,
        DataList,
    },
    data(){
        return{
            tipoLiquidacion: [],
            fields: [
                {
                name: "descripcion",
                label: "",
                type: "title",
                class: ""
                }
            ],
        }
    },
    created(){
    },
    mounted(){

    },
    methods:{
        mostrarOpciones(tipoLiquidacion) {
            console.log(tipoLiquidacion);
            Swal.fire({
                title: tipoLiquidacion.descripcion,
                showCancelButton: true,
                confirmButtonText: "Editar",
                cancelButtonText: "Eliminar",
                confirmButtonColor: "#f7b924",
                cancelButtonColor: "#d33",
                reverseButtons: true
            }).then(result => {
                if (result.value) {
                this.$router.push({name:'EditarTipoLiquidacion', params:{id:tipoLiquidacion.id}})
                } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
                ) {
                this.eliminarTipoLiquidacion(tipoLiquidacion)
                }
            });
        },        
        eliminarTipoLiquidacion(tipoLiquidacion) {
        Swal.fire({
            title: "¿Estás seguro?",
            text: `¿Deseas eliminar ${tipoLiquidacion.descripcion} de manera permanente?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
            this.loading = true;
            axios
                .delete("tipoliquidacion/" + tipoLiquidacion.id)
                .then(res => {
                    console.log(res.data);
                Swal.fire(
                    "Eliminado",
                    `${res.data.tipoliquidacion.descripcion} se ha eliminado con éxito.`,
                    "success"
                );
                this.$refs.datatable.update();
                })
                .catch(err => console.log(err))
                .finally(() => (this.loading = false));
            }
        });
        }
    },
}
</script>
